module.exports = __webpack_public_path__ + "img/bg-mision-2-26.05f257b0.jpg";